/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

import { isEmpty } from '@ember/utils';

export default class PaperBadge extends Component {
  // count is the value to display within the badge.
  count = null;

  // info, if true, sets the colour of the badge to match the app's colour, for
  // informational purposes.
  @tracked info = false;

  // pillClass allows a custom CSS class to be added to the "pill" for
  // context-specific styling.
  @tracked pillClass = '';

  // pillClasses determines the CSS classes to apply to the actual "pill".
  get pillClasses() {
    let classNames = ['paper-badge', 'paper-badge--pill'];
    if (this.info) {
      classNames.push('paper-badge--info');
    }
    if (!isEmpty(this.pillClass)) {
      classNames.push(this.pillClass);
    }

    return classNames.join(' ');
  }
}
